"use client";

import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default function AOSInit() {
  useEffect(() => {
    AOS?.init({
      duration: 600,
      easing: 'ease-out',
      once: true,
      offset: 50,
      disable: false,
      anchorPlacement: 'top-center',
      startEvent: 'load',
      disableMutationObserver: false,
    });

    // Refresh AOS on route changes to ensure animations work properly
    AOS?.refresh();
  }, []);

  return null;
}